export default function SearchBarSmall({searchTerm, handleSearchChange}) {
    return (
        <>
            <div className="input-group input-group-sm py-3">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Buscar"
                    name="buscador"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    aria-label="Sizing example input" 
                    aria-describedby="inputGroup-sizing-sm"
                    autoComplete="off"
                />
            </div>
        </>
    );
}